import { fetcher } from './fetcher';

class API {
	login({ username, password, rememberMe }) {
		return fetcher.request({
			method: 'post',
			url: 'login',
			data: {
				username,
				password,
				rememberMe,
			},
		});
	}

	getStates() {
		return fetcher.request({
			method: 'get',
			url: 'states',
		});
	}

	getReminders() {
		return fetcher.request({
			method: 'get',
			url: 'reminders',
		});
	}

	createReminder(dto) {
		return fetcher.request({
			method: 'post',
			url: 'reminders',
			data: dto,
		});
	}

	getCallLogs() {
		return fetcher.request({
			method: 'get',
			url: 'call-logs',
		});
	}

	createCallLog(dto) {
		return fetcher.request({
			method: 'post',
			url: 'call-logs',
			data: dto,
		});
	}

	updateCallLog( callLogId, dto ) {
		return fetcher.request( {
			method : 'patch',
			url : `call-logs/${callLogId}`,
			data : dto,
		} )
	}

	deleteCallLog( callLogId ) {
		return fetcher.request( {
			method : 'delete',
			url : `call-logs/${callLogId}`
		} )
	}

	getLead(leadId) {
		return fetcher.request({
			method: 'get',
			url: `leads/${leadId}`,
		});
	}

	createLead( dto ) {
		return fetcher.request( {
			method: 'post',
			url: 'leads',
			data: dto,
		} )
	}

	updateLead( leadId, dto ) {
		return fetcher.request( {
			method : 'Patch',
			url : `leads/${leadId}`,
			data : dto,
		} )
	}

	getLeadReminders(leadId) {
		return fetcher.request({
			method: 'get',
			url: `leads/${leadId}/reminders`,
		});
	}

	getLeadCallLogs(leadId) {
		return fetcher.request({
			method: 'get',
			url: `leads/${leadId}/call-logs`,
		});
	}
}

export const api = new API();
